import { createFileRoute } from '@tanstack/react-router';
import AuthFormStyling from '@/lib/auth/components/AuthFormStyling';
import TextInput from '@/lib/common/inputs/TextInput';
import useAxios from '@/machinery/useAxios';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@heroui/react';
import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { object, string } from 'yup';

const schema = object().shape({
    email: string().required().email().label('Email'),
});

type FormType = {
    email: string;
};
export const Route = createFileRoute('/auth/forgot-password')({
    component: RouteComponent,
});

function RouteComponent() {
    const { ax, loading } = useAxios();
    const [submitted, setSubmitted] = useState<boolean>(false);
    const f = useForm<FormType>({
        resolver: yupResolver(schema),
        defaultValues: {
            email: undefined,
        },
        mode: 'onChange',
    });

    const onSubmit = useCallback(
        async (data: FormType) => {
            await ax({
                method: 'post',
                url: '/auth/forgot-password',
                data: {
                    email: data.email,
                },
                callback: () => {
                    setSubmitted(true);
                },
            });
        },
        [ax],
    );

    return (
        <AuthFormStyling>
            {!submitted && (
                <FormProvider {...f}>
                    <form onSubmit={f.handleSubmit(onSubmit)}>
                        <div className='flex flex-col gap-2'>
                            <TextInput type='text' name='email' label='Email' placeholder='Email' />
                            <Button
                                color='primary'
                                className='btn-primary w-full'
                                type='submit'
                                isDisabled={loading}>
                                Send reset password link
                            </Button>
                        </div>
                    </form>
                </FormProvider>
            )}
            {submitted && (
                <div>
                    <div>Email sent.</div>
                    <div>Please check your email for a reset password link.</div>
                </div>
            )}
        </AuthFormStyling>
    );
}
